import { useCallback, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { useIsMobile } from '@s20/components/common/Hide';
import { IconButton } from '../common/forms/FormElements';
import { Alert } from '../common/Modal';
import { QuickSearchBody } from './QuickSearchBody';

const QuickSearch = () => {
    const isMobile = useIsMobile();

    const open = useCallback(() => {
        Alert.show({
            size: 'lg',
            body: <QuickSearchBody />,
        });
    }, []);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault();
                open();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [open]);

    return (
        <IconButton
            onClick={open}
            title="Quick Search (Cmd+K)"
            size="xl"
            className={isMobile ? '' : 'mr-2'}
        >
            <FontAwesomeIcon
                icon={faSearch}
                size="sm"
            />
        </IconButton>
    );
};

export default QuickSearch;
